var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIraq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C6.84042 0 2.4419 3.2565 0.746384 7.82611H23.2536C21.5581 3.2565 17.1596 0 12 0Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739H0.746384C2.4419 20.7435 6.84041 24 12 24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13045 11.2174C9.12389 11.2174 9.11747 11.2178 9.1109 11.2179V11.2174H6.81698C6.93328 10.768 7.341 10.4347 7.82611 10.4347V8.86954C6.38765 8.86954 5.21742 10.0398 5.21742 11.4782V12.7565V12.7826H9.1109H9.13045C9.27431 12.7826 9.39131 12.8997 9.39131 13.0435V13.5652H4.17389V15.1304H10.9565V13.0434C10.9565 12.0366 10.1373 11.2174 9.13045 11.2174Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 13.5652V8.86954H11.4783V15.1304H14.087V13.5652H13.0435Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2608 13.5652V8.86954H16.6956V13.5652H16.1739V12H14.6087V15.1305H19.3043V13.5652H18.2608Z",
    fill: "#496E2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraq);
export default __webpack_public_path__ + "static/media/iraq.f058c24159e5f906b923e44c202e8073.svg";
export { ForwardRef as ReactComponent };